import getBuiltIn$1 from './get-built-in.js';
import './object-define-property.js';
import wellKnownSymbol$1 from './well-known-symbol.js';
import descriptors from './descriptors.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var getBuiltIn = getBuiltIn$1;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol = wellKnownSymbol$1;
var DESCRIPTORS = descriptors;
var SPECIES = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  }
};

export { setSpecies as default };
